import { Dispatch, SetStateAction, useState } from "react";
import PopupModelWrapper from "../wrappers/PopupModelWrapper";
import { Stack, Typography } from "@mui/material";
import PopupButton from "../common/PopupButton";
import useData from "src/hooks/useApi";
import useMessage from "../../hooks/useMessage";
import {
    dateSelectBoxButtonStyle,
    dateSelectBoxButtonTitleStyle,
    dateSelectDomainNameStyle,
} from "./modelStyles";
import { Order, DropScheduleRecord } from "./PreBackorderModel";
import PreBackorderScheduleTable from "../table/PreBackorderScheduleTable";
import { formatDate } from "src/utils/helperFunctions";

type DateSelectType = {
    isOpen: boolean;
    domain: Order[];
    schedule: DropScheduleRecord[];
    setIsOpen: Dispatch<SetStateAction<boolean>>;
    setReloadData: Dispatch<SetStateAction<number>>;
};

const SelectPrebackorderDateModel = (props: DateSelectType) => {
    const { isOpen, domain, schedule, setIsOpen, setReloadData } = props;

    const { showSuccess } = useMessage();

    // State for selected schedule item
    const [selectedIndex, setSelectedIndex] = useState(
        schedule.findIndex((row) => row.isValid),
    );

    const { postData } = useData();
    const { showError } = useMessage();

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const executePlacePrebackorder = async () => {
        const selectedDate = schedule[selectedIndex];

        try {
            setIsLoading(true);

            const response: any = await postData("bid/placePreBackorder", {
                domainName: domain[0].domainName,
                bidAmount: selectedDate.fee,
            });

            if (!response) {
                throw new Error("Place Prebackorder Request Failed");
            }

            if (response.isSuccess) {
                showSuccess(
                    `Pre-Backorder for ${domain[0].domainName} placed successfully!. The drop date will be updated shortly.`,
                );
                return;
            } else {
                showError(response.error);
            }
        } catch (error: any) {
            showError("Some Error Occurred, Please Try Again Later !");
        } finally {
            setIsLoading(false);
            handleClose();
            setReloadData(Date.now() / 1000);
        }
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    const handleSubmitClick = async () => {
        await executePlacePrebackorder();
    };

    return (
        <PopupModelWrapper
            open={isOpen}
            handleClose={handleClose}
            width={{ xs: "80%", sm: "300px", md: "350px" }}
            title="Pre-Backorder Domain"
        >
            <Stack spacing={1} mt={3}>
                <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                >
                    <Typography sx={dateSelectBoxButtonTitleStyle}>
                        Domain Name :
                    </Typography>
                    <Typography sx={dateSelectDomainNameStyle}>
                        {domain[0].domainName}
                    </Typography>
                </Stack>
                <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                >
                    <Typography sx={dateSelectBoxButtonTitleStyle} width={220}>
                        Selected Pre-Backorder Date:
                    </Typography>
                    <Typography sx={dateSelectBoxButtonStyle}>
                        {selectedIndex >= 0 &&
                            schedule[selectedIndex] &&
                            formatDate(schedule[selectedIndex].dropTimeMS)}
                    </Typography>
                </Stack>
                <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                >
                    <Typography sx={dateSelectBoxButtonTitleStyle} width={220}>
                        Bid Value ($):
                    </Typography>
                    <Typography sx={dateSelectBoxButtonStyle}>
                        {selectedIndex >= 0 &&
                            schedule[selectedIndex] &&
                            schedule[selectedIndex].fee.toFixed(2)}
                    </Typography>
                </Stack>
            </Stack>
            <Stack
                sx={{
                    my: 3,
                    maxHeight: "50dvh",
                    overflowY: "auto",
                }}
            >
                <PreBackorderScheduleTable
                    schedule={schedule}
                    selectedIndex={selectedIndex}
                    setSelectedIndex={setSelectedIndex}
                />
            </Stack>
            <Stack direction="row" justifyContent="flex-end">
                <PopupButton triggerFunction={handleClose} type="cancel">
                    Cancel
                </PopupButton>
                <PopupButton
                    triggerFunction={handleSubmitClick}
                    type="proceed"
                    disabled={selectedIndex < 0}
                    isLoading={isLoading}
                >
                    Submit
                </PopupButton>
            </Stack>
        </PopupModelWrapper>
    );
};

export default SelectPrebackorderDateModel;
